"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeTable = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var BaseTable_1 = tslib_1.__importDefault(require("../calendar/tables/BaseTable"));
var TimeCombobox_1 = require("./TimeCombobox");
function TimeTable(_a) {
    var caption = _a.caption, props = tslib_1.__rest(_a, ["caption"]);
    return (react_1.default.createElement(BaseTable_1.default, { caption: caption },
        react_1.default.createElement(TimeCombobox_1.Combobox, tslib_1.__assign({}, props))));
}
exports.TimeTable = TimeTable;
TimeTable.displayName = "TimeTable";
//# sourceMappingURL=TimeTable.js.map